import type { CSSProperties } from 'react';
import { useTenantBranding, type Identity } from '@cusp/api-client';
import './institutionMark.css';

/** The name beside the mark labels it; an uploaded logo replaces the initials. */
export function InstitutionMark({
  identity,
  fallback,
  className,
  style,
}: {
  identity: Identity | null;
  fallback: string;
  className: string;
  style?: CSSProperties;
}) {
  const branding = useTenantBranding(identity);
  const logo = branding.data?.logo ?? null;
  return (
    <span
      className={`${className}${logo === null ? '' : ' institution-mark-logo'}`}
      style={style}
      aria-hidden="true"
    >
      {logo === null ? fallback : <img src={logo} alt="" />}
    </span>
  );
}
